const defaultState = () => {
  return {
    categoryStates: {},
  };
};

const getters = {
  categoryStates: state => state.categoryStates,
};

const mutations = {
  setCategoryStates(state, categoryStates) {
    if (!categoryStates || !Array.isArray(categoryStates)) {
      return;
    }
    for (let categoryState of categoryStates) {
      const stored = state.categoryStates[categoryState.categoryId];
      if (stored && stored.mobileCreatedAt > categoryState.mobileCreatedAt) continue;
      state.categoryStates[categoryState.categoryId] = categoryState;
    }
  },
  deleteCategoryStates(state, categoryId) {
    delete state.categoryStates[categoryId];
  },
  reset(state) {
    Object.assign(state, defaultState());
  },
};

const actions = {
  fetchCategoryStates({ dispatch, commit, getters, rootGetters }) {
    return rootGetters['session/ajax'].get('/category_states').then(response => {
      if (response.data.records) {
        commit('setCategoryStates', response.data.records);
      } else {
        commit('setCategoryStates', response.data.categoryStates);
      }
    });
  },
  sendCategoryState({ dispatch, commit, getters, rootGetters }, params) {
    commit('setCategoryStates', [params]);
    return rootGetters['session/ajax'].post('/category_states', params).then(response => {
      return response;
    }).then(() => {
      return dispatch('fetchCategoryStates');
    });
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
